export default __webpack_public_path__ + "d50aa7e388ae4bd7d6586ee491026fe9.png";